import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Home_about from "./home-about/Home_about";
import Why_nutricos from "./why-nutricos/Why_nutricos";
import Related_category from "./related-category/Related_category";
import Why_clients from "./why-clients/Why_clients";
import Services from "./services/Services";
import Enquire_now from "./enquire_now/Enquire_now";
import All_video from "./all-video/All_video";
import Testimonials from "./testimonials/Testimonials";
import Aim_To_Scale_Up from "./aim_to_scale_up/Aim_To_Scale_Up";
import Our_Philosophy from "./our-philosophy/Our_Philosophy";
import NutricosBanner from "./nutricos_banner/Nutricos_Banner";
import Meet_Section from "./meet_section/Meet_Section";

function Home() {
  return (
    <>
      <Banner />
      <Meet_Section/>
      {/* <Services /> */}
      {/* <Home_about /> */}
      {/* <Related_category /> */}
      <Why_nutricos />

      <Our_Philosophy />
      {/* <Home_about /> */}
      {/* <Related_category /> */}
      <Why_clients />

      {/* <All_video /> */}
      <Testimonials />
      {/* <Aim_To_Scale_Up /> */}
      {/* <Aim_To_Scale_Up /> */}

      <NutricosBanner />
      <Enquire_now />
    </>
  );
}

export default Home;
